import { useContext } from "react";
import { ConfigurationContext } from "contexts";

/** Get the app version from the configuration.
 *
 * @param {object} config The configuration.
 *
 */
const getAppVersion = (config) => {
  if (config.isWindows) {
    return config.windowsAppVersion;
  }
  if (config.isMacOS) {
    return config.macAppVersion;
  }
  console.log("App version not found.");
  return "0.0";
};

/** Get the app OS (windows, mac, chrome) from the configuration.
 *
 *  @param {object} config The configuration.
 *
 */
const getAppOs = (config) => {
  if (config.isWindows) {
    return "windows";
  }
  if (config.isMacOS) {
    return "macos";
  }

  console.log("App OS not found.");
  return "";
};

/** App Detection hook to use the detection library's application detection process.
 *
 *  @param {function} onProgress Progress handler.
 *  @param {function} onDone Done handler.
 *  @param {function} onError Error handler.
 *
 */
export const useAppDetection = (onProgress, onDone, onError) => {
  let config = useContext(ConfigurationContext);

  const run = () => {
    // Configure the host.
    var subDomain = window.location.hostname
      .toLowerCase()
      .replace(".systemrequirementslab.com", "");
    if (
      subDomain !== "test.cyri" &&
      subDomain !== "prod.cyri" &&
      subDomain !== "www"
    ) {
      subDomain = "www";
    }

    // Set the detection settings.
    window.SRL.detection.init({
      loggingLevel: config.loggingLevel,
      host: subDomain, //window.location.hostname.toLowerCase().replace(".systemrequirementslab.com",""),
      //    host: "www",
      protocol: "https",
      referrerId: config.referrerId,
      computerId: config.computerId,
      detectionAppVersion: getAppVersion(config),
      detectionAppOs: getAppOs(config),
      onProgress: onProgress,
      onError: onError,
      onDone: onDone,
      requirementSetId: config.requirementSetId,
    });

    // Run the detection.
    window.SRL.detection
      .runAppScan()
      .then(() => {})
      .catch((error) => {
        console.log(`Caught ${error.name} error: ${error.message}`);
      });
  };

  return run;
};
